import React, { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { products, formatPrice } from '../data/products';
import { useCart } from '../context/CartContext';
import { loadFingerprintIfNeeded } from '../utils/fingerprint';
import { useToast } from './Toast';
import './ProductDetailScreen.css';

export default function ProductDetailScreen() {
  const { productId } = useParams<{ productId: string }>();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const { show } = useToast();
  
  const product = useMemo(() => 
    products.find((p) => p.id === productId), [productId]
  );

  if (!product) {
    return <div className="product-detail-error">Product not found</div>;
  }

  const handleAddToCart = () => {
    void loadFingerprintIfNeeded('add-to-cart');
    addToCart(product);
    show('Item added to cart');
    navigate('/');
  };

  return (
    <div className="product-detail-container">
      <img src={product.imageUrl} alt={product.title} className="product-detail-image" />
      <h1 className="product-detail-title">{product.title}</h1>
      <p className="product-detail-price">{formatPrice(product.priceCents)}</p>
      <p className="product-detail-description">{product.description}</p>
      
      <button className="add-to-cart-button" onClick={handleAddToCart}>
        Add to Cart
      </button>
    </div>
  );
}
